<div class="switch-container">
    <span class="switch-label" [class.active]="!isChecked"> {{ 'SWITCH.' + labelLeft | translate }}</span>
    <mat-slide-toggle 
      [checked]="isChecked" 
      (change)="onChanged($event)">
    </mat-slide-toggle>
    <span class="switch-label" [class.active]="isChecked"> {{ 'SWITCH.' + labelRight | translate }}</span>
  </div>